import React from "react";
import { Button } from "./Elements";
import { useSelector } from "react-redux";

export const Answered = ({
  display,
  questions = [],
  socketRef,
  liveEvent,
  setQuestions,
  height,
}) => {
  const { token } = useSelector((state) => state.users);
  const event_id = liveEvent?.public_id ?? liveEvent?.id;

  return (
    <div
      style={{
        display: display ? "block" : "none",
        paddingTop: "20px",
        paddingLeft: "20px",
        height: height,
        overflow: "auto",
      }}
    >
      <ul>
        {questions.length > 0 ? (
          questions
            .filter((q) => q.status === "answered" || q.response)
            .sort((a, b) => b.relevance - a.relevance)
            .map((question, index) => (
              <li
                key={index}
                style={{
                  fontSize: "16px",
                  marginBottom: "10px",
                  width: "100%",
                  border: "1px solid #d0d0d0",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  padding: "5px 10px",
                  flexDirection: "column",
                }}
              >
                <div>{question?.message}</div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#808080",
                    fontStyle: "italic",
                  }}
                >
                  From: {question?.user.nickname}
                </div>
                <div>Answer: {question?.response || "No answer provided."}</div>
                <div>Answer Source: {question?.response_source || "N/A"}</div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                >
                  <Button
                    bgcolor="#f87171"
                    textcolor="#ffffff"
                    onClick={() => {
                      socketRef.current.emit("update-message-status", {
                        token: token,
                        event_id: event_id,
                        broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                        message_id: question.public_id,
                        status: "approved",
                      });
                      setQuestions((prevQuestions) =>
                        prevQuestions.map((q) =>
                          q.public_id === question.public_id
                            ? { ...q, status: "approved" }
                            : q
                        )
                      );
                    }}
                  >
                    <i className="fas fa-check-circle"></i>
                    Unanswer
                  </Button>
                </div>
              </li>
            ))
        ) : (
          <li>No questions available.</li>
        )}
      </ul>
    </div>
  );
};

export default Answered;
